import React from 'react';
import { Spinner } from 'react-bootstrap';

const SmallSectionLoader = ({ text = 'Loading...' }) => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center w-100 py-5">
      <Spinner animation="border" role="status" />
      <span className="mt-2 text-muted">{text}</span>
    </div>
  );
};

export default SmallSectionLoader;
